import styled from "styled-components";
import {useApp} from "../../contexts/app";
import {ContainerImage} from "../../components/Container";
import {Body, Desc, Images, Logo, PageIcon} from "../404/style";
import {LogoIcon} from "../../components/Header";
import {Input, message} from "antd";
import {ButtonSubmit} from "../../components/Button";
import {
    addCallUser,
    delCallUser, getThreadDetail,
    popUpdateCallInfoProfile,
    postJoinCall,
    putUpdateCallInfoProfile, sleep,
} from "../../services/app";
import {useParams} from "react-router-dom";
import React, {useRef, useState} from "react";
import {initTencentCall, sentCallStateMessage} from "../Success/Call/tencent";
import Call from "../Success/Call";
import {ChatHeader} from "../Success/Chat/style";
import {ChatSDK} from "@tencentcloud/chat";
import {TUICallType} from "tuicall-engine-webrtc";
import produce, {current} from "immer";

export default function OutsideCall(props) {
    const {T} = useApp();
    const params = useParams();
    const {threadId, roomId, callType} = params;
    const [loading, setLoading] = useState(false);
    const callRef = useRef<any>();
    const [calling, setCalling] = useState(false);
    const [view, setView] = useState<'history' | 'chat' | 'call'>('chat');
    const [name, setName] = useState<string>("");
    const [thread, setThread] = useState<{
        chatSDK?: ChatSDK;
        callEngine?: any;
        tencentUserId?: string;
        tencentGroupId?: string;
        endChatAt?: string;
        name?: string;
        threadId?: string;
        hidden?: boolean;
    }>(null);
    const timerAutoEndCallRef = useRef<any>({});
    const previousCallRef = useRef<any>(null);

    const onSubmit = async () => {
        if (!name || name.length < 1) {
            message.error(T("Please enter your name with at least 1 characters."));
            return;
        }

        setLoading(true);
        let result = previousCallRef.current;
        if (!previousCallRef.current) {
            result = await postJoinCall(threadId)
        }
        const detailThread = await getThreadDetail(threadId);
        const tencentGroupId = detailThread?.data?.data?.tencentGroupId || threadId;

        if (result.status !== 200) {
            result = await postJoinCall(tencentGroupId)
        }

        if (detailThread?.status !== 200 || !detailThread?.data?.data?.isCalling) {
            message.error(T("This is not a valid call or the call has ended."));
            setLoading(false);
            return;
        }

        if (result?.status === 200) {
            previousCallRef.current = {
                status: 200,
                data: result?.data || {}
            };
            const data = result?.data?.data;
            const configLocal = {
                tencentSdkAppId: data?.tencentSdkAppId,
                tencentCustomerUserId: data?.tencentCustomerUserId,
                userSig: data?.userSig,
            };
            // Init call engine if needed
            const callEngine = await initTencentCall({
                appId: parseInt(configLocal.tencentSdkAppId),
                userId: configLocal.tencentCustomerUserId,
                userSig: configLocal.userSig
            });
            if (callEngine) {
                await callEngine.setSelfInfo({
                    nickName: name || "",
                    avatar: 'https://null.png',
                });

                const userInfo = {};
                userInfo[configLocal.tencentCustomerUserId] = {
                    userID: configLocal.tencentCustomerUserId,
                    nick: name || "",
                    nickName: name || "",
                    avatar: 'https://null.png',
                };
                await putUpdateCallInfoProfile(threadId, userInfo).catch(reason => null);

                setThread({
                    chatSDK: null,
                    callEngine: callEngine,
                    tencentUserId: configLocal.tencentCustomerUserId,
                    tencentGroupId: tencentGroupId,
                    endChatAt: data?.endChatAt,
                    name: tencentGroupId,
                    threadId: threadId,
                });

                await callEngine.tim.joinGroup({groupID: tencentGroupId}).then(console.log).catch(reason => {
                    console.log("Failed to join group", reason);
                    // message.error(T("Failed to join the call group."));
                })
                await callEngine.setSelfInfo({
                    nickName: name || "",
                    avatar: 'https://null.png',
                });
                await callRef.current.onJoinCall({
                    roomID: parseInt(roomId),
                    type: callType,
                    callType: parseInt(callType) || TUICallType.VIDEO_CALL,
                    groupID: tencentGroupId,
                    isHost: false,
                });
            }
        } else {
            // show error message this is not a valid call
            message.error(T("This is not a valid call or the call has ended."));
        }
        setLoading(false);
    }

    const onAutoEndCall = async (callInfo) => {
        if (timerAutoEndCallRef?.current?.timer) {
            clearTimeout(timerAutoEndCallRef.current.timer);
        }
        timerAutoEndCallRef.current = {
            timer: setTimeout(() => {
                callRef.current.endCall();
                message.info(T("Call has been ended automatically after 1 hour"));
            }, 1000 * 60 * 60 * 1), // Auto end call after 1 hours
            roomID: callInfo?.roomID || thread?.tencentGroupId,
        }
    }

    return (
        <ContainerImage
            style={{overflowY: 'auto', minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Logo>
                <LogoIcon/>
            </Logo>
            <Body>
                <Title>{T("Enter your name")}</Title>
                <TextInput
                    style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <InputView
                        placeholder={T("Your name...")}
                        style={{maxWidth: 500}} autoSize={{minRows: 1, maxRows: 1}} value={name}
                        onChange={e => setName(e.target.value)}/>
                </TextInput>
                <ButtonSubmit loading={loading} onClick={onSubmit} style={{width: 200}}>{T("Join now")}</ButtonSubmit>
            </Body>
            {
                <div style={{
                    position: 'fixed',
                    left: calling ? 0 : 10000,
                    top: 0,
                    zIndex: 1000,
                    width: '100%',
                    height: '100%'
                }}>
                    <ChatHeader
                        view={'chat'}
                        setView={setView}
                        calling={!!calling}
                        name={(thread?.name || "")}
                    />
                    <Call
                        view={'call'}
                        user={{
                            fullName: name,
                            avatar: "",
                            userName: thread?.tencentUserId
                        }}
                        ref={callRef}
                        callEngine={thread?.callEngine}
                        onUserLeave={(userID) => {
                            console.log("onUserLeave", userID);
                            sleep(1000).then(() => {
                                delCallUser(threadId, userID).finally(() => {
                                })
                            });
                        }}

                        onStartCall={(callInfo) => {
                            setView('call');
                            onAutoEndCall(callInfo)
                            setThread(produce(draft => {
                                const currentDraft = current(draft);
                                addCallUser(currentDraft?.threadId, currentDraft?.tencentUserId).finally(() => {
                                    sentCallStateMessage(currentDraft?.callEngine?.tim, currentDraft?.tencentGroupId, {
                                        tencentUserId: currentDraft?.tencentUserId,
                                        tencentGroupId: currentDraft?.tencentGroupId,
                                        threadId: currentDraft?.threadId,
                                        name: currentDraft?.name || "",
                                        isCalling: false,
                                    }, "CALL-JOIN-STATE").then()
                                });
                            }))
                        }}
                        onEndCall={() => {
                            setCalling(false);
                            setThread(produce(draft => {
                                const currentDraft = current(draft);
                                delCallUser(currentDraft?.threadId, currentDraft?.tencentUserId).finally(() => {
                                    // remove user from callInfo
                                    popUpdateCallInfoProfile(currentDraft?.threadId, currentDraft?.tencentUserId).then();
                                    sentCallStateMessage(currentDraft?.callEngine?.tim, currentDraft?.tencentGroupId, {
                                        tencentUserId: currentDraft?.tencentUserId,
                                        tencentGroupId: currentDraft?.tencentGroupId,
                                        threadId: currentDraft?.threadId,
                                        name: currentDraft?.name || "",
                                        isCalling: false,
                                    }, "CALL-LEAVE-STATE").then()
                                });
                            }));
                            if (timerAutoEndCallRef?.current?.timer) {
                                clearTimeout(timerAutoEndCallRef.current.timer);
                            }
                            timerAutoEndCallRef.current = {
                                timer: null,
                                roomID: null,
                            };
                        }}
                        onChange={(calling, callInfo) => {
                            console.log('onChange', calling, callInfo);
                            setCalling(calling);
                        }}
                        mode={'customer'}
                    />
                </div>
            }
        </ContainerImage>
    );
}

const Title = styled.div`
    color: #FFF;
    text-align: center;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;
const TextInput = styled.div`
    padding: 20px 24px;
    width: 100%;
`;

const InputView = styled(Input)`
    height: 50px;
    border-color: #BEBEBE !important;
    border-radius: 12px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #636363;

    &:focus, &.ant-input-outlined:focus-within {
        box-shadow: none !important;
    }

    .ant-input-affix-wrapper .ant-input-clear-icon {
        font-size: 15px;
    }
`;
